import { EonUiIcon } from "@eon-ui/eon-ui-components-react";
import { useTranslation } from "@me8eon/translation";
import { SelectFilterButton } from "./SelectFilterButton";
import { SearchTextFilter } from "@me8eon/searchtext_filters";
import { useFilterPlugins, useGuiFilters } from "@me8eon/filters";
import { cleanFilters } from "@me8eon/all_filters";
import React from "react";
import { useDebug } from "@me8eon/debug";
import { searchDebugName } from "@me8eon/filter_data_widget";

export const FilterHeader: React.FC = () => {
    const t = useTranslation();
    const [guiFilters, setGuiFilters] = useGuiFilters();
    const filterPlugins = useFilterPlugins();
    const debug = useDebug(searchDebugName);
    const searchFilterClick = () => {
        const cleanedGuiFilters: SearchTextFilter = cleanFilters(guiFilters, filterPlugins);
        debug("FilterHeader.searchFilterClick", cleanedGuiFilters);
        setGuiFilters(cleanedGuiFilters);
    };
    return (
        <div className="search-filter-header refine-filters-container">
            <div className="filter-header-left">
                <EonUiIcon
                    className="eon-ui-svg-icon"
                    scheme="red500"
                    size="normal"
                    key={"funnel-icon"}
                    name="filter"
                ></EonUiIcon>
                <span className="filter-heading">{t("filterPage.filterMenu.refineResults")}</span>
            </div>
            <SelectFilterButton
                isReset={true}
                onClick={searchFilterClick}
                // onClick={searchFilterClick("all", setters.setDataType, setters.setSearchIndex)}
                textkey="filterPage.filterMenu.reset"
                dataType="all"
            />
        </div>
    );
};